import { render, staticRenderFns } from "./TeacherProfileSection.vue?vue&type=template&id=2dfde6e2&scoped=true"
import script from "./TeacherProfileSection.vue?vue&type=script&lang=js"
export * from "./TeacherProfileSection.vue?vue&type=script&lang=js"
import style0 from "./TeacherProfileSection.vue?vue&type=style&index=0&id=2dfde6e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfde6e2",
  null
  
)

export default component.exports